import { render, staticRenderFns } from "./MypageInfo.vue?vue&type=template&id=0bda1c2c&"
import script from "./MypageInfo.vue?vue&type=script&lang=ts&"
export * from "./MypageInfo.vue?vue&type=script&lang=ts&"
import style0 from "./MypageInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports